import { useEffect, useState } from "react";
import { useSearchParams, Link } from "react-router-dom";
import axios from "axios";
import { API } from "@/lib/api";
import { Check, X } from "lucide-react";

export default function Desinscription() {
  const [params] = useSearchParams();
  const jeton = params.get("jeton");
  const [state, setState] = useState({ status: "loading", message: "" });

  useEffect(() => {
    if (!jeton) {
      setState({ status: "error", message: "Lien de désinscription invalide (jeton manquant)." });
      return;
    }
    axios
      .post(`${API}/desinscription`, { jeton })
      .then((r) => {
        const ok = r.data.status === "desinscrit";
        setState({ status: ok ? "done" : "error", message: r.data.message });
      })
      .catch(() => setState({ status: "error", message: "Une erreur est survenue." }));
  }, [jeton]);

  return (
    <div data-testid="screen-desinscription" style={{ maxWidth: 560 }}>
      <h1 style={{ fontSize: "1.6rem" }}>Désinscription</h1>
      {state.status === "loading" && <p style={{ color: "var(--muted)" }}>Traitement…</p>}
      {state.status === "done" && (
        <div className="pc-card" data-testid="desinscription-success" style={{ background: "var(--accent-soft)", borderColor: "var(--accent)" }}>
          <div style={{ display: "flex", gap: "0.6rem", alignItems: "flex-start" }}>
            <Check size={20} color="var(--accent)" style={{ marginTop: 2 }} />
            <p style={{ margin: 0 }}>{state.message} Vous ne recevrez plus de notification pour cette commune.</p>
          </div>
        </div>
      )}
      {state.status === "error" && (
        <div className="pc-card" data-testid="desinscription-error" style={{ background: "var(--warn-soft)", borderColor: "#E4D8BE" }}>
          <div style={{ display: "flex", gap: "0.6rem", alignItems: "flex-start" }}>
            <X size={20} color="var(--warn)" style={{ marginTop: 2 }} />
            <p style={{ margin: 0 }}>{state.message}</p>
          </div>
        </div>
      )}
      <p style={{ marginTop: "1.2rem" }}><Link to="/" data-testid="desinscription-home">Retour à l'accueil</Link></p>
    </div>
  );
}
